export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.voicemail-list', {
      url: 'voicemail',
      template: '<nets-voicemail-list></nets-voicemail-list>',
    });
};
